module.exports = __webpack_public_path__ + "assets/HKNova-Heavy.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Heavy.woff
// module id = 124
// module chunks = 0